import React, { Fragment } from 'react';
import { Box, Divider, SxProps, Typography } from '@mui/material';

const itemContainer: SxProps = {
  display: 'flex',
  alignItems: 'center'
};

const container: SxProps = {
  display: 'flex',
  alignItems: 'center',
  gap: 1
};

const MetaDataItem: React.FC<{
  icon?: React.ReactNode;
  content: string | React.ReactNode;
}> = ({ icon, content }) => {
  return (
    <Box sx={itemContainer}>
      {icon ? <Box sx={{ mr: 0.5 }}>{icon}</Box> : null}
      {typeof content === 'string' ? (
        <Typography>{content}</Typography>
      ) : (
        content
      )}
    </Box>
  );
};

type Props = {
  items: Array<{ icon?: React.ReactNode; content: string | React.ReactNode }>;
};

export const MetaDataBar: React.FC<Props> = ({ items }) => {
  return (
    <Box sx={container}>
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <Fragment key={`item_${index}`}>
            <MetaDataItem {...item} />
            {!isLast && (
              <Divider
                orientation="vertical"
                variant="middle"
                flexItem
                sx={{
                  height: '1rem'
                }}
              />
            )}
          </Fragment>
        );
      })}
    </Box>
  );
};
